import { SITE_SERVER_URL, postOptions } from "../index";
import {
    AllCorrectionResponse,
    CorrectionAddArg,
    CorrectionForMediaResponse,
    GetAllCorrectionArg,
    SetCorrectionStatusArg,
} from "./commentsTypes";

export const getAllCorrectionsApi = async ({
    offset,
    limit,
    status,
    language,
    media,
    sort_by,
}: GetAllCorrectionArg): Promise<AllCorrectionResponse> => {
    const params = new URLSearchParams({
        offset: offset.toString(),
        limit: limit.toString(),
    });
    if (status) {
        params.set("status", status);
    }
    if (language) {
        params.set("language", language);
    }
    if (media) {
        params.set("media", media);
    }
    if (sort_by) {
        params.set("sort_by", sort_by);
    }
    const response = await fetch(`${SITE_SERVER_URL}/corrections?${params.toString()}`);
    if (!response.ok) {
        throw new Error("cant get all corrections");
    }
    return await response.json();
};

export const getCorrectionsForMediaApi = async ({
    mediaId,
}: {
    mediaId: string;
}): Promise<CorrectionForMediaResponse> => {
    const response = await fetch(`${SITE_SERVER_URL}/corrections/${mediaId}`);
    if (!response.ok) {
        throw new Error("cant get  corrections for media");
    }
    return await response.json();
};

export const setCorrectionStatusApi = async ({
    mediaId,
    status,
    correctionId,
}: SetCorrectionStatusArg): Promise<unknown> => {
    const response = await fetch(`${SITE_SERVER_URL}/corrections/${mediaId}/${correctionId}`, {
        ...postOptions,
        body: JSON.stringify({ status }),
    });
    return response.json();
};

export const correctionAddApi = async (
    mediaId: string,
    body: CorrectionAddArg,
): Promise<unknown> => {
    const response = await fetch(`${SITE_SERVER_URL}/corrections?media=${mediaId}`, {
        ...postOptions,
        body: JSON.stringify(body),
    });
    return response.json();
};
